import { render, staticRenderFns } from "./CardContentTypes.vue?vue&type=template&id=4b2ce634"
import script from "./CardContentTypes.vue?vue&type=script&lang=js"
export * from "./CardContentTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports